/* PDP redo island (2026-08-11): Prose gallery dots/arrows, honest delivery
   countdown + date ranges, companion add-on, buy-now / qty-aware cart adds.
   Standalone on purpose — the minified botanica-film.js bundle keeps handling
   qty steppers, variant price and the plain qty-1 add; this file only takes
   over the cases the bundle cannot do (buy now, companion, qty > 1). */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /* ---------- gallery ---------- */
  function gallery() {
    var root = document.querySelector('[data-pdpg]');
    if (!root) return;
    var track = root.querySelector('[data-pdpg-track]');
    var dotsBox = root.querySelector('[data-pdpg-dots]');
    var prev = root.querySelector('[data-pdpg-prev]');
    var next = root.querySelector('[data-pdpg-next]');
    if (!track || !dotsBox) return;

    var slides = [];
    function visibleSlides() {
      return Array.prototype.filter.call(
        track.querySelectorAll('[data-pdpg-slide]'),
        function (s) { return s.offsetParent !== null; }
      );
    }
    function buildDots() {
      slides = visibleSlides();
      dotsBox.textContent = '';
      if (slides.length < 2) return;
      slides.forEach(function (slide, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to image ' + (i + 1));
        if (i === 0) b.className = 'is-active';
        b.addEventListener('click', function () {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
        dotsBox.appendChild(b);
      });
    }
    function syncDots() {
      if (slides.length < 2) return;
      var x = track.scrollLeft + track.clientWidth / 2;
      var active = 0;
      slides.forEach(function (s, i) { if (s.offsetLeft <= x) active = i; });
      Array.prototype.forEach.call(dotsBox.children, function (d, i) {
        d.classList.toggle('is-active', i === active);
      });
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncDots);
    }, { passive: true });
    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { step(-1); e.preventDefault(); }
      if (e.key === 'ArrowRight') { step(1); e.preventDefault(); }
    });
    buildDots();
    var mq = window.matchMedia('(max-width: 768px)');
    var onchange = function () { buildDots(); syncDots(); };
    if (mq.addEventListener) mq.addEventListener('change', onchange);
    else mq.addListener(onchange);
  }

  /* ---------- delivery countdown + dates ---------- */
  function ptParts() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles', hour12: false,
      year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { if (p.type !== 'literal') o[p.type] = parseInt(p.value, 10); });
    if (o.hour === 24) o.hour = 0;
    return o;
  }
  function addBizDays(utcNoon, n) {
    var d = new Date(utcNoon.getTime());
    while (n > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      var wd = d.getUTCDay();
      if (wd !== 0 && wd !== 6) n--;
    }
    return d;
  }
  function nextBizDay(utcNoon) {
    var d = new Date(utcNoon.getTime());
    while (d.getUTCDay() === 0 || d.getUTCDay() === 6) d.setUTCDate(d.getUTCDate() + 1);
    return d;
  }
  function fmt(d) { return MONTHS[d.getUTCMonth()] + ' ' + d.getUTCDate(); }
  function fmtRange(a, b) {
    if (a.getUTCMonth() === b.getUTCMonth()) return fmt(a) + ' – ' + b.getUTCDate();
    return fmt(a) + ' – ' + fmt(b);
  }

  function shipBlock() {
    var box = document.querySelector('[data-pdp-ship]');
    if (!box) return;
    var cutoffEl = box.querySelector('[data-ship-cutoff]');
    var d1 = box.querySelector('[data-ship-d1]');
    var d2 = box.querySelector('[data-ship-d2]');

    function tick() {
      var p = ptParts();
      var minsNow = p.hour * 60 + p.minute;
      var cutoff = 12 * 60;
      var today = new Date(Date.UTC(p.year, p.month - 1, p.day, 12));
      /* Orders are processed seven days a week. Keep this timer under 24 hours:
         before noon it targets today; after noon it targets tomorrow. Shipping
         estimates below continue to use business days. */
      var mins = minsNow < cutoff
        ? cutoff - minsNow
        : (24 * 60) - minsNow + cutoff;
      if (cutoffEl) {
        cutoffEl.textContent = 'Order within ';
        var b = document.createElement('b');
        b.textContent = Math.floor(mins / 60) + 'h ' + (mins % 60) + 'm';
        cutoffEl.appendChild(b);
        cutoffEl.appendChild(document.createTextNode(' for the fastest delivery.'));
      }
      /* handling 0-2 business days, transit 3-5 business days — the same terms
         published in the Product JSON-LD. Weekend or post-cutoff orders start
         the clock on the next business day. */
      var start = minsNow < cutoff ? nextBizDay(today) : nextBizDay(addBizDays(today, 1));
      var shipEnd = addBizDays(start, 2);
      var delStart = addBizDays(start, 3);
      var delEnd = addBizDays(start, 7);
      if (d1) d1.textContent = fmtRange(start, shipEnd);
      if (d2) d2.textContent = fmtRange(delStart, delEnd);
    }
    tick();
    setInterval(tick, 30000);
  }

  /* ---------- companion add-on ---------- */
  var companionVariant = 0;
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function companion() {
    var box = document.querySelector('[data-pdp-companion]');
    if (!box) return;
    var pid = box.getAttribute('data-product-id');
    if (!pid) return;
    /* a shampoo/conditioner/kit gets its pair chosen server-side (same line's other half, or a
       mask/oil/leave-in for a kit); everything else still asks the recommendations engine */
    var pinned = box.getAttribute('data-pdp-companion-handle');
    var source = pinned
      ? fetch('/products/' + pinned + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (prod) { return prod ? { products: [prod] } : null; })
      : fetch('/recommendations/products.json?product_id=' + pid + '&limit=4&intent=related')
          .then(function (r) { return r.ok ? r.json() : null; });
    source
      .then(function (data) {
        if (!data || !data.products) return;
        var p = data.products.filter(function (x) {
          /* salon-only = professional/wholesale products (e.g. the Nanoplasty Keratin
             Treatment) — never offer them to retail customers as an add-on */
          var gated = (x.tags || []).some(function (t) { return String(t).toLowerCase() === 'salon-only'; });
          return !gated && x.available && String(x.id) !== String(pid) && x.variants && x.variants.length;
        })[0];
        if (!p) return;
        var label = document.createElement('span');
        label.className = 'pdp-mate__label';
        label.textContent = 'Pairs well with';
        var card = document.createElement('label');
        card.className = 'pdp-mate__card';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        var sticky = document.querySelector('.pdp__stickyprice');
        var baseCents = sticky ? Number(sticky.getAttribute('data-price-cents')) : 0;
        cb.addEventListener('change', function () {
          companionVariant = cb.checked ? p.variants[0].id : 0;
          /* phone sticky bar shows the true total when the companion rides along
             (ponytail: priced off the first variant; the sticky bar already ignores
             variant switches, so this matches its existing behavior) */
          if (sticky && baseCents) sticky.textContent = money(baseCents + (cb.checked ? p.price : 0));
        });
        var thumb = document.createElement('span');
        thumb.className = 'pdp-mate__thumb';
        if (p.featured_image) {
          var img = document.createElement('img');
          img.src = p.featured_image;
          img.alt = '';
          img.loading = 'lazy';
          thumb.appendChild(img);
        }
        var meta = document.createElement('span');
        var name = document.createElement('span');
        name.className = 'pdp-mate__name';
        name.textContent = p.title;
        var price = document.createElement('span');
        price.className = 'pdp-mate__price';
        price.textContent = 'Add for ' + money(p.price);
        meta.appendChild(name);
        meta.appendChild(document.createElement('br'));
        meta.appendChild(price);
        card.appendChild(cb);
        card.appendChild(thumb);
        card.appendChild(meta);
        box.appendChild(label);
        box.appendChild(card);
        box.hidden = false;
      })
      .catch(function () { /* recommendations down -> row stays hidden */ });
  }

  /* ---------- cart adds the bundle cannot do ---------- */
  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) {
        var html = json && json['cart-drawer'];
        var current = document.getElementById('cart-drawer');
        if (!html || !current) return;
        var t = document.createElement('template');
        t.innerHTML = html;
        var fresh = t.content.querySelector('#cart-drawer');
        if (!fresh) return;
        var wasOpen = current.classList.contains('is-open');
        current.replaceWith(fresh);
        if (wasOpen) fresh.classList.add('is-open');
        fresh.setAttribute('aria-hidden', fresh.classList.contains('is-open') ? 'false' : 'true');
      });
  }
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-open');
  }
  function addItems(items, signal) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
      signal: signal
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); });
  }

  var buyNow = false;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-buy-now]');
    buyNow = !!b;

    /* phone sticky Add: when the companion is checked, take over from the bundle
       (capture + stopPropagation beats its document-level bubble listener) so BOTH
       items land in the bag. Companion unchecked -> bundle's proven path. */
    var s = e.target && e.target.closest && e.target.closest('[data-sticky-add]');
    if (!s || !companionVariant) return;
    e.preventDefault();
    e.stopPropagation();
    var qtyInput = document.querySelector('.pdp__qty input');
    var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
    var id = Number(s.dataset.variant);
    if (!id) return;
    s.setAttribute('disabled', '');
    addItems([{ id: id, quantity: qty }, { id: companionVariant, quantity: 1 }])
      .then(function () { return refreshDrawer().then(openDrawer); })
      .catch(function () { /* leave cart untouched on failure */ })
      .then(function () { s.removeAttribute('disabled'); });
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-cart-add]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"], select[name="id"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var id = idInput ? Number(idInput.value) : 0;
    var qty = Math.max(1, Number(qtyInput && qtyInput.value) || 1);
    var wantBuyNow = buyNow;
    buyNow = false;
    if (!id) return;
    if (!wantBuyNow && !companionVariant && qty === 1) return; /* bundle's path, proven */

    e.preventDefault();
    e.stopPropagation();
    var items = [{ id: id, quantity: qty }];
    if (companionVariant) items.push({ id: companionVariant, quantity: 1 });
    var submitBtn = e.submitter || form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.setAttribute('disabled', '');
    /* a hung /cart/add.js (flaky mobile network) must never strand the tap — after 6s
       ABORT the in-flight fetch (else a slow-but-alive add completes server-side AND the
       native fallback posts again = double add, council catch) and fall through to the
       native form post */
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = new Promise(function (_, rej) {
      setTimeout(function () { if (ctrl) ctrl.abort(); rej(new Error('timeout')); }, 6000);
    });
    Promise.race([addItems(items, ctrl && ctrl.signal), timeout])
      .then(function () {
        if (wantBuyNow) { window.location.href = '/checkout'; return; }
        return refreshDrawer().then(openDrawer);
      })
      .catch(function () { form.submit(); /* server-rendered fallback */ })
      .then(function () { if (submitBtn) submitBtn.removeAttribute('disabled'); });
  }, true);

  function init() {
    gallery();
    shipBlock();
    companion();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
